<div
  fxLayout="row"
  [ngClass]="marginCustom"
  class="ps-divider-container ps-divider-margin"
  *ngIf="divider">
  <mat-progress-bar
    mode="determinate"
    [value]="progress"
    color="primary"
    class="ps-save-progress"
    *ngIf="progress > 0"
    [ngClass]="{'ps-save-progress-hidden': progress === 100}">
  </mat-progress-bar>
  <div fxFlex="100">
    <mat-divider></mat-divider>
  </div>
</div>
<div fxLayout="row" fxLayout="row"  fxLayout.xs="column" style="padding: 20px 0px;">
    <div fxFlex fxLayoutAlign="start center" *ngIf="lastChange">
        <span class="ps-save-edt-info">
          Última atualização: {{last_change | date:'dd/MM/yyyy'}} às {{last_change | date:'HH:mm:ss'}} por {{changed_by}}
        </span>
        <!-- <span class="ps-save-edt-info">Última atualização: 10/11/2019 às 14:00 por {{changed_by}}</span> -->
    </div>
    <div fxFlex fxLayoutAlign="end center" class="ps-save-edt-container-button">
        <a
          mat-stroked-button
          [disabled]="form.pristine"
          #button
          (click)="actionButtonOptional(button)"
          (click)="restForm(button)">
          Limpar alterações
        </a>
        <button *ngIf="!custumSubmit" [buttonLoader]="uploadDone" mat-raised-button color="primary" [disabled]="!form.valid"
          type="submit">
          Salvar
        </button>
        <button *ngIf="custumSubmit" [buttonLoader]="uploadDone" mat-raised-button color="primary" (click)="custumSubmitEvent()"
          [disabled]="!form.valid" type="submit">
          Salvar
        </button>
    </div>
</div>
